module.exports = __webpack_public_path__ + "static/media/image.0e45b566.png";